import { render, staticRenderFns } from "./jrfxsssj.vue?vue&type=template&id=484c17c0"
import script from "./jrfxsssj.vue?vue&type=script&lang=js"
export * from "./jrfxsssj.vue?vue&type=script&lang=js"
import style0 from "./jrfxsssj.vue?vue&type=style&index=0&id=484c17c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports